// This module injects child id and child name values into hidden form elements
// on the connecting us product page

// --------------------------------------------------------------------------
// Imports
// --------------------------------------------------------------------------

import * as wv from '../global/worldvision';

// --------------------------------------------------------------------------
// Globals
// --------------------------------------------------------------------------
export const MODULE_NAME = 'inject_childinfo';
export let global_vars = {};

// --------------------------------------------------------------------------
//
// --------------------------------------------------------------------------

export function url_child_data(global) {
    let url_params = wv.get_obj(global, 'url_params');
    let set_childid = false;
    let set_child_first_name = false;
    let data = {};
    for (let [key, val] of Object.entries(url_params)) {
        if (!set_childid && key.match(/^childid$/i)) {
            data.childid = val;
            set_childid = true;
        }

        if (!set_child_first_name && key.match(/^child_first_name$/i)) {
            data.child_first_name = val;
            set_child_first_name = true;
        }

        if (set_childid && set_child_first_name) {
            break;
        }
    }

    return data;
}

export function initialize(global) {
    let doc = global.document;
    let childid_form = doc.querySelector('#childID');
    let firstname_form = doc.querySelector('#name');

    let child_data = url_child_data(global);

    if ('childid' in child_data) {
        childid_form.value = child_data.childid;
    }

    if ('child_first_name' in child_data) {
        firstname_form.value = child_data.child_first_name;
    }
}
